import ClearIcon from '@assets/icons/clear.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Text, TouchableOpacity, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  isLastStep?: boolean;
  onClose: () => void;
  title: string;
}

const CLOSE_BUTTON_DIMENSIONS = 20;

export const SampleRequestFollowUpStepHeader: React.FC<Props> = ({
  isLastStep,
  onClose,
  title,
}) => {
  const [styles] = useStyles();
  const { isSmallLayout } = useLayoutContext();

  return (
    <View style={styles.titleWrapper}>
      <Text style={[TYPOGRAPHY.h2, styles.titleStyle]}>{title}</Text>
      {isLastStep ? (
        <Button
          onPress={onClose}
          size="xsmall"
          style={styles.doneButton}
          textStyle={[TYPOGRAPHY.large, FONTS.primaryBold]}
          trackingData={{
            name: 'sample_request_follow_up_add_to_order_guide.done_button',
          }}
          type="tertiary"
        >
          {i18n.t('done')}
        </Button>
      ) : !isSmallLayout ? (
        <View style={styles.closeButton}>
          <TouchableOpacity onPress={onClose}>
            <ClearIcon
              height={CLOSE_BUTTON_DIMENSIONS}
              width={CLOSE_BUTTON_DIMENSIONS}
            />
          </TouchableOpacity>
        </View>
      ) : null}
    </View>
  );
};

const useStyles = createStyles(() => ({
  closeButton: {
    height: CLOSE_BUTTON_DIMENSIONS,
    marginTop: 6,
    width: CLOSE_BUTTON_DIMENSIONS,
  },
  doneButton: {
    marginTop: 4,
    paddingHorizontal: 0,
  },
  titleStyle: {
    marginBottom: 24,
  },
  titleWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
